import { Button } from "primereact/button";
import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import UpdateCompanyForm from "./UpdateCompanyForm";

function UpdateCompany({ data, getAllCompanies }) {
  const [showModal, setShowModal] = useState(false);
  if (data === null) {
    return null;
  }
  const onCloseModal = () => {
    setShowModal(false);
  };
  return (
    <>
      <Button
        icon="pi pi-pencil"
        onClick={() => setShowModal(true)}
        className="p-button-rounded p-button-warning p-mr-2"
        tooltip="Update Company"
        tooltipOptions={{ position: "top" }}
      />
      <Dialog
        visible={showModal}
        style={{ width: "70vw" }}
        onHide={onCloseModal}
      >
        <UpdateCompanyForm
          formData={data}
          onCloseModal={onCloseModal}
          getAllCompanies={getAllCompanies}
        />
      </Dialog>
    </>
  );
}

export default UpdateCompany;
